import { api } from '..'

export const deleteTag = (tagId: string) => () =>
  api.delete(`/v1/tags/${tagId}`)
